type JwtPayload = {
  exp?: number;
};

const decodeBase64Url = (value: string): string => {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");

  if (typeof globalThis.atob !== "function") {
    return "";
  }

  return globalThis.atob(padded);
};

const decodeJwtPayload = (token: string): JwtPayload | null => {
  const segments = token.split(".");
  if (segments.length < 2) {
    return null;
  }

  try {
    const payload = decodeBase64Url(segments[1]);
    const data = JSON.parse(payload) as JwtPayload;
    return data;
  } catch {
    return null;
  }
};

/**
 * Whether the token expires within `withinMs`.
 *
 * Callers use this to decide whether a forced token refresh is worth its cost,
 * so an undecodable or `exp`-less token answers `true`: refreshing needlessly is
 * cheaper than carrying a token the server will reject.
 */
export const isTokenExpiringWithin = (token: string, withinMs: number): boolean => {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") {
    return true;
  }

  return payload.exp * 1_000 - Date.now() < withinMs;
};
